import type React from "react";
import { createPortal } from "react-dom";
import { Toaster as SonnerToaster, toast as sonnerToast } from "sonner";

// Keep props type from sonner Toaster
type ToasterProps = React.ComponentProps<typeof SonnerToaster>;

// Global Sonner Toaster configured for top-right, below header, above all modals.
// Portaled to a dedicated #toast-root so it bypasses any app stacking contexts.
const Toaster = (props: ToasterProps) => {
  if (typeof document === "undefined") return null;

  const root = document.getElementById("toast-root");
  if (!root) return null;

  return createPortal(
    <SonnerToaster
      position="top-right"
      offset={80}
      richColors
      closeButton
      style={{ zIndex: 2147483647 }}
      toastOptions={{
        classNames: {
          toast: "z-[2147483647]",
        },
        style: {
          zIndex: 2147483647,
        },
      }}
      {...props}
    />,
    root,
  );
};

export { Toaster, sonnerToast as toast };
